import React from "react";
import Classes from "./styles/style.module.css";

const PodiumText = ({ scores, name }) => {
  return (
    <div>
      <p className={Classes.podiumText}>{name}</p>
      <div className={Classes.scoreContainer}>{scores}</div>
    </div>
  );
};

export default PodiumText;
